import { gql } from "@apollo/client";

export const QUERY_MY_TRUCK_LIST = gql`
  query MyTrucks($orderBy: [String], $first: Int, $last: Int, $before: String, $after: String) {
    myTrucks(orderBy: $orderBy, first: $first, last: $last, before: $before, after: $after) {
      data {
        timePosted
        modfied
        id
        originAddress
        originCity
        destinationCity
        destinationAddress
        originIso2
        originCountry
        destinationCountry
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        originRadius
        destinationRadius
        areaCode
        targetRate
        length
        weight
        timeEnd
        timeStart
        matchDate
        details
        notificationPush
        notificationEmail
        matches
        linehaulDistance
        duration
        isDeleted
        originRegion {
          id
          originStates
          destinationStates
        }
        destinationRegion {
          id
          originStates
          destinationStates
        }
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        trailerTypes {
          id
          loadtypes
          loadChoiceFull
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const MUTATION_REMOVE_TRUCK = gql`
  mutation RemoveTruck($id: ID!) {
    removeTruck(id: $id) {
      success
    }
  }
`;
